import React from 'react';
import AnimatedSVG from '../AnimatedSVG';

function wrapperStyle({ styles }) {
  return styles.toEdgeStyle;
}

function backgroundStyle({ styles, mode, color }) {
  const inactive = mode >= 7;

  let style = Object.assign({}, styles.toEdgeStyle, {
    backgroundColor: color.blue.a700,
    transition: `all 600ms ease-in-out`
  });

  if (inactive) {
    style = {
      ...style,
      opacity: 0
    };
  }

  return style;
}

function contentStyle({ styles }) {
  return Object.assign({}, styles.toEdgeStyle, styles.centerStyle);
}

function loaderWrapperStyle({ styles }) {
  return styles.toEdgeStyle;
}

function loaderStyle({ mode, dimensions, constants }) {
  const { width, height } = dimensions;
  const active = mode === 1;

  return {
    width: constants.SIGN_LOADER_SIZE,
    height: constants.SIGN_LOADER_SIZE,
    opacity: active ? 1 : 0,
    transition: `all 600ms ease-in-out`,
    position: 'absolute',
    top: height / 2 - constants.SIGN_LOADER_SIZE / 2,
    left: width / 2 - constants.SIGN_LOADER_SIZE / 2
  };
}

function infoWrapperStyle({ mode, dimensions, constants }) {
  const { width, height } = dimensions;
  const center = mode < 5;
  const corner = mode >= 5;
  const visible = (mode >= 2 && mode <= 3) || mode >= 6;
  const shiftUp = mode >= 2 && mode < 5;

  const halfHeight = height / 2;
  const halfLineOneFontSize = constants.SIGN_LINE_ONE_FONT_SIZE / 2;
  const halfSignFontSize = constants.SIGN_SIGN_LARGE_FONT_SIZE / 2;

  let style = {
    position: 'absolute',
    bottom:
      height / 2 -
      constants.SIGN_LINE_ONE_FONT_SIZE -
      constants.SIGN_SIGN_LARGE_FONT_SIZE -
      constants.SIGN_LOADER_SIZE / 2 -
      24,
    left: 0,
    width
  };

  if (center) {
    style = {
      ...style
    };
  }

  if (shiftUp) {
    style = {
      ...style,
      bottom: halfHeight - halfLineOneFontSize - halfSignFontSize,
      transition: `all 600ms ease-in-out`
    };
  }

  if (corner) {
    style = {
      ...style,
      left: constants.SIGN_INFO_MARGIN,
      bottom: constants.SIGN_INFO_MARGIN
    };
  }

  if (visible) {
    style = {
      ...style,
      opacity: 1
    };
  } else {
    style = {
      ...style,
      opacity: 0
    };
  }

  return style;
}

function lineOneWrapperStyle({ dimensions, constants }) {
  const { width } = dimensions;

  return {
    height: constants.SIGN_LINE_ONE_FONT_SIZE,
    width
  };
}

function lineOneStyle({ styles, mode, constants }) {
  const active = mode > 1 && mode < 4;

  return {
    ...styles.fontStyle,
    textAlign: 'center',
    opacity: active ? 1 : 0,
    transform: active
      ? `translateY(0px)`
      : `translateY(${constants.SIGN_ANIMATION_DISTANCE}px)`,
    transition: `all 600ms ease-in-out`,
    fontSize: constants.SIGN_LINE_ONE_FONT_SIZE,
    fontWeight: 100,
    color: '#FFFFFF'
  };
}

function lineTwoWrapperStyle({ mode, dimensions, constants }) {
  const { width } = dimensions;
  const hide = mode < 5;

  return {
    height: constants.SIGN_LINE_TWO_FONT_SIZE,
    width,
    display: hide ? 'none' : 'block'
  };
}

function lineTwoStyle({ styles, mode, constants }) {
  const inactive = mode < 6;
  const active = mode === 6;

  let style = {
    ...styles.fontStyle,
    transition: `all 600ms ease-in-out`,
    fontSize: constants.SIGN_LINE_TWO_FONT_SIZE,
    fontWeight: 100,
    color: '#FFFFFF'
  };

  if (inactive) {
    style = {
      ...style,
      opacity: 0,
      transform: `translateY(${constants.SIGN_ANIMATION_DISTANCE}px)`
    };
  } else if (active) {
    style = {
      ...style,
      opacity: 1,
      transform: `translateY(0)`
    };
  }

  return style;
}

function signWrapperStyle({ mode, dimensions, constants }) {
  const { width } = dimensions;
  const corner = mode >= 5;

  return {
    height: corner
      ? constants.SIGN_SIGN_SMALL_FONT_SIZE
      : constants.SIGN_SIGN_LARGE_FONT_SIZE,
    width
  };
}

function signStyle({ styles, mode, constants }) {
  const active = (mode >= 2 && mode <= 3) || mode >= 6;
  const corner = mode >= 5;

  let style = {
    ...styles.fontStyle,
    transition: `all 600ms ease-in-out`,
    textAlign: 'center',
    fontSize: constants.SIGN_SIGN_LARGE_FONT_SIZE,
    fontWeight: 100,
    color: '#FFFFFF'
  };

  if (active) {
    style = {
      ...style,
      opacity: 1,
      transform: `translateY(0)`
    };
  } else {
    style = {
      ...style,
      opacity: 0,
      transform: `translateY(${constants.SIGN_ANIMATION_DISTANCE}px)`
    };
  }

  if (corner) {
    style = {
      ...style,
      textAlign: 'left',
      fontSize: constants.SIGN_SIGN_SMALL_FONT_SIZE
    };
  }

  return style;
}

export default props => (
  <div style={wrapperStyle(props)}>
    <div style={backgroundStyle(props)} />
    <div style={contentStyle(props)}>
      <div style={loaderWrapperStyle(props)}>
        <div style={loaderStyle(props)}>
          <AnimatedSVG
            visible
            path="/loaders/loader_01.json"
            size={props.constants.SIGN_LOADER_SIZE}
          />
        </div>
      </div>
      <div style={infoWrapperStyle(props)}>
        <div style={lineOneWrapperStyle(props)}>
          <div style={lineOneStyle(props)}>{props.text.SIGN_LOADER_LINE_ONE}</div>
        </div>
        <div style={lineTwoWrapperStyle(props)}>
          <div style={lineTwoStyle(props)}>{props.text.SIGN_LOADER_LINE_TWO}</div>
        </div>
        <div style={signWrapperStyle(props)}>
          <div style={signStyle(props)}>{props.name}</div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loader/index.js